import React from 'react';
import styled from 'styled-components';

// Dark: Moody dark cards with purple glow accents, stacked full-width
const DarkTheme = ({ colorTheme }: { colorTheme: string }) => {
   return (
      <Wrapper>
         <Card>
            <CardGlow />
            <Row>
               <Left>
                  <Tag>3 Hrs</Tag>
                  <Title>Unlimited Internet</Title>
               </Left>
               <Price>₱50</Price>
            </Row>
            <Btn>Get Now</Btn>
         </Card>
         <Card>
            <Row>
               <Left>
                  <Tag>1 Day</Tag>
                  <Title>Unlimited Internet</Title>
               </Left>
               <Price>₱80</Price>
            </Row>
            <Btn>Get Now</Btn>
         </Card>
         <Card>
            <Row>
               <Left>
                  <Tag>3 Days</Tag>
                  <Title>Unlimited Internet</Title>
               </Left>
               <Price>₱150</Price>
            </Row>
            <Btn>Get Now</Btn>
         </Card>
      </Wrapper>
   );
};

const Wrapper = styled.div`
   display: flex; flex-direction: column; gap: 5px;
`;
const Card = styled.div`
   position: relative; background: #1a1a2e; border: 1px solid #2a2a3e;
   border-radius: 8px; padding: 8px; overflow: hidden;
`;
const CardGlow = styled.div`
   position: absolute; top: -10px; right: -10px; width: 30px; height: 30px;
   background: radial-gradient(circle, rgba(167,139,250,0.3) 0%, transparent 70%);
`;
const Row = styled.div`display: flex; justify-content: space-between; align-items: center;`;
const Left = styled.div``;
const Tag = styled.span`
   font-size: 7px; font-weight: 700; background: rgba(167,139,250,0.15);
   color: #a78bfa; padding: 1px 5px; border-radius: 3px;
`;
const Title = styled.p`font-size: 9px; font-weight: 600; color: #e2e8f0; margin-top: 3px;`;
const Price = styled.span`font-size: 14px; font-weight: 800; color: #a78bfa;`;
const Btn = styled.div`
   margin-top: 6px; background: #a78bfa; color: #0f0f17; text-align: center;
   font-size: 8px; font-weight: 700; padding: 4px; border-radius: 5px;
`;

export default DarkTheme;
